const record = value => value && typeof value === 'object' && !Array.isArray(value);
const MAP_STATES = new Set(['desktop_unavailable', 'missing_local', 'current', 'update_available',
  'published_unavailable', 'invalid_local_manifest', 'invalid_published_manifest']);
export function validAssetObservation(kind, value) {
  if (!record(value)) return false;
  if (value.local != null && !record(value.local)) return false;
  if (kind === 'map') return MAP_STATES.has(value.status)
    && (value.local == null || typeof value.local.installed === 'boolean')
    && (!['current', 'update_available'].includes(value.status) || (value.local?.installed === true && typeof value.local.version === 'string'));
  return typeof value.checked === 'boolean' && (value.local == null || typeof value.local.state === 'string');
}
export function routingIsCurrent(value) {
  return value?.checked === true && value?.local?.state === 'installed'
    && value?.compatible === true && value?.updateAvailable === false;
}
export function assetActionAllowed(kind, action, status) {
  if (!validAssetObservation(kind, status)) return false;
  if (kind === 'map') return action === 'install'
    ? ['missing_local', 'update_available'].includes(status.status)
    : status.local?.installed === true && status.local?.rollbackAvailable === true;
  if (action === 'rollback') return status.local?.state === 'installed' && status.local?.rollbackAvailable === true;
  if (status.compatible === false) return false;
  return ['not_installed', 'installed_unmanaged'].includes(status.local?.state)
    || (status.checked === true && status.updateAvailable === true && status.local?.state === 'installed');
}
export function assetMutationOutcome(kind, action, result) {
  if (!record(result) || result.pending === true) return 'unknown';
  if (result.cancelled === true && result.ok === false) return 'cancelled';
  if (kind === 'routing') {
    if (result.ok === false) return 'refused';
    const staged = result.staged || result;
    if (staged.status === 'staged' && staged.restartRequired === true) return 'handoff';
    return 'unknown';
  }
  return result.installed === true && result.status === (action === 'install' ? 'installed' : 'rolled_back')
    ? 'complete' : 'unknown';
}
